import './helpLink.scss'

//To format correctly help links should be placed inside a ul with className="icon-font-list"

const HelpLink = ({
  className,
  url,
  title,
  children,
}) => (
  <a className={`help-link ${className}`} href={url} target="_blank"><li className="icon-font-list__list-item icon-font-list__list-item--open_in_new">{title || children}</li></a>
)

export default HelpLink



// WEBPACK FOOTER //
// ./app/components/HelpLink.js